<!-- src/components/ThemeSwitcher.vue -->
<template>
  <a
    href="javascript:void(0)"
    class="nav-link"
    role="button"
    @click.prevent="toggleMode"
  >
    <i :class="darkMode ? 'fas fa-sun' : 'fas fa-moon'"></i>
  </a>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const darkMode = ref(false)

const applyMode = (val) => {
  document.body.classList.toggle('dark-mode', val)
  localStorage.setItem('adminlteDark', val)
}

const toggleMode = () => {
  darkMode.value = !darkMode.value
  applyMode(darkMode.value)
}

onMounted(() => {
  darkMode.value = localStorage.getItem('adminlteDark') === 'true'
  applyMode(darkMode.value)
})
</script>